import { HeadWrapper as TableHeadWrapper, Th as TableTh } from '#app/components/Table/styles';
import React from 'react';
import { useAppSelector } from '#app/hooks/useAppStore';

const TableHeaders = ({ accountText }) => {
  const i18n = useAppSelector((s) => s.i18n);
  return (
    <TableHeadWrapper style={{ borderTop: 'none' }}>
      <TableTh flexWidth="2%" />
      <TableTh flexWidth="8%">{i18n.incomeOutcome.date}</TableTh>
      <TableTh flexWidth="3%" />
      <TableTh flexWidth="12%">{i18n.incomeOutcome.sum}</TableTh>
      <TableTh flexWidth="17%">{i18n.incomeOutcome.category}</TableTh>
      <TableTh flexWidth="15%">{i18n.incomeOutcome.subcategory}</TableTh>
      <TableTh flexWidth="17%">{i18n.incomeOutcome.tag}</TableTh>
      <TableTh flexWidth="15%">{i18n.incomeOutcome.desc}</TableTh>
      <TableTh flexWidth="13%">{accountText}</TableTh>
    </TableHeadWrapper>
  );
};

export default TableHeaders;
